import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import TrackingPurchasing from "../../../containers/modules/report/tracking-purchasing";

export default function TrackingPurchasingRoutes(props) {
  const { authUser } = props;
  return (
    <Route
      path="tracking-purchasing"
      index
      element={
        <AccessControl
          name={"Report Tracking Purchasing"}
          auth={authUser}
          component={() => <TrackingPurchasing />}
        />
      }
    ></Route>
  );
}
